import React from "react";
import "./index.scss";
import { Controller } from "react-hook-form";

const Input = ({
  type = "text",
  placeholder,
  onInputChange = undefined,
  name,
  rules,
  required = true,
  disabled = false,
  control,
  errors,
  suffix = null,
  prefix = null,
  className = "",
  label = "",
  defaultValue = "",
  min,
  max,
  onChange,
  value,
  ...props
}) => {
  const getFieldError = (errors, name) => {
    return name
      ?.split(".")
      .reduce((acc, part) => acc && acc[part], errors);
  };

  const fieldError = getFieldError(errors, name);

  return (
    <div className={`input-group ${className}`}>
      {label && <label>{label}</label>}
      <div className="input-field">
        {prefix && (
          <div className="input--prefix">
            {typeof prefix === "function" ? prefix() : prefix}
          </div>
        )}
        <Controller
          name={name}
          control={control}
          rules={rules}
          defaultValue={defaultValue}
          render={({ field }) => (
            <input
              type={type}
              required={required}
              disabled={disabled}
              placeholder={placeholder}
              {...field}
              value={value !== undefined ? value : field.value || ""}
              onChange={(e) => {
                field.onChange(e);
                if (onChange) {
                onChange(e);
                }
                if (onInputChange) {
                  onInputChange(e);
                }
              }}
              // min={min}
              // max={max}
              minLength={min} // Ensures minimum length validation
              maxLength={max} // Ensures maximum length validation
              className={`form-control ${fieldError ? "input__invalid" : ""}`}
              {...props}
            />
          )}
        />
        {suffix && (
          <div className="input--suffix">
            {typeof suffix === "function" ? suffix() : suffix}
          </div>
        )}
      </div>
      {fieldError && (
        <div className="input--helper__invalid">
          {fieldError?.message}
        </div>
      )}
    </div>
  );
};

export default Input;
